export default __webpack_public_path__ + "8a8bf66be38205682feb33fe273c5598.svg";